import { render, staticRenderFns } from "./ViewRequirement.vue?vue&type=template&id=db480c88&scoped=true&"
import script from "./ViewRequirement.vue?vue&type=script&lang=js&"
export * from "./ViewRequirement.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequirement.vue?vue&type=style&index=0&id=db480c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db480c88",
  null
  
)

export default component.exports